import React from 'react';
import './Shimmer.css';

const MenuShimmer = () => {
  return (
    <div className="menu-shimmer">
      <div className="menu-shimmer-image"></div>
      <div className="menu-shimmer-text"></div>
    </div>
  );
};

export default MenuShimmer; 